import { render, staticRenderFns } from "./componentLinkSmall.vue?vue&type=template&id=7b462962&scoped=true"
import script from "./componentLinkSmall.vue?vue&type=script&lang=js"
export * from "./componentLinkSmall.vue?vue&type=script&lang=js"
import style0 from "./componentLinkSmall.vue?vue&type=style&index=0&id=7b462962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b462962",
  null
  
)

export default component.exports